import gql from 'graphql-tag';

export const SUBSCRIBE = gql`
  subscription ($scope: String = "DEFAULT", $topic: [String]!, $withMovingLines: Boolean = false) {
    update(scope: $scope, subscribeTo: $topic) {
      id
      status
      displayed
      currentPriceNum
      currentPriceDen
      ancestors
      hcapValue
      isInPlay
      movingLines @include(if: $withMovingLines) {
        displayed
        status
        cashOutAvailable
        minPricedLine
        maxPricedLine
        lineIncrement
        linePrices {
          line
          displayed
          cashOutAvailable
          selections {
            selectionType
            currentPriceNum
            currentPriceDen
          }
        }
      }
    }
  }
`;

export const SUBSCRIBELIVE = gql`
  subscription ($eventIds: [String!]!) {
    livescores(eventIds: $eventIds) {
      eventId
      startTime
      ... on TennisLivescore {
        server
        setsPerMatch
        currentGame
        currentSet
        postMatch
        scores {
          team
          gamePoints
          setPoints {
            set
            points
          }
          matchPoints
        }
      }
      ... on SoccerLivescore {
        period
        gameTime {
          minutes
          seconds
        }
        scores {
          team
          goals
        }
        strPeriod
      }
      ... on FootballLivescore {
        gameTime {
          minutes
          seconds
        }
        quarter
        scores {
          team
          points
        }
      }
      ... on BasketballLivescore {
        period
        gameTime {
          minutes
          seconds
        }
        scores {
          team
          points
        }
      }
      ... on BaseballLivescore {
        inning {
          number
          half
        }
        scores {
          team
          runs
        }
      }
      ... on HockeyLivescore {
        period
        gameTime {
          minutes
          seconds
        }
        scores {
          team
          goals
        }
      }
    }
  }
`;

export const DEVICE_UPDATES_SUBSCRIPTION_ALL_MESSAGES = gql`
  subscription ($schemaVersion: String!, $venueId: String, $slotIdIn: [SlotIdInput!]) {
    sub: peripheralMessages(where: { schemaVersion: $schemaVersion, venueId: $venueId, slotIdIn: $slotIdIn }) {
      metadata {
        request {
          id
          peripheral
          deviceId
        }
        message {
          id
          topic
          offset
          type
        }
      }
      payload {
        ... on DeviceStatusMessagePayload {
          deviceId
          locked
          disabled
          status
        }
      }
    }
  }
`;

export const DEVICE_UPDATES_SUBSCRIPTION_FILTERED = gql`
  subscription ($schemaVersion: String!, $venueId: String, $slotIdIn: [SlotIdInput!], $messageTypes: [String!]!) {
    sub: peripheralMessages(
      where: { schemaVersion: $schemaVersion, venueId: $venueId, slotIdIn: $slotIdIn, messageTypes: $messageTypes }
    ) {
      metadata {
        request {
          id
          peripheral
          deviceId
        }
        message {
          id
          topic
          offset
          type
        }
      }
      payload {
        ... on DeviceStatusMessagePayload {
          deviceId
          locked
          disabled
          status
        }
      }
    }
  }
`;

export const MONEY_MESSAGES_SUBSCRIPTION = gql`
  subscription ($venueId: String!, $deviceType: String!, $slotNumber: Int!, $messageTypes: [String!]!) {
    sub: moneyMessages(
      where: {
        schemaVersion: "1.0.0"
        venueId: $venueId
        deviceType: $deviceType
        slotNumber: $slotNumber
        messageTypes: $messageTypes
      }
    ) {
      metadata {
        request {
          id
          venueId
        }
        message {
          topic
          offset
          type
        }
      }
      payload {
        timestamp
        ... on NoteDepositRejectedPayload {
          reasons {
            message
            errorCode
          }
        }
        ... on BalanceChangeMessagePayload {
          accountId
          balances {
            type
            change
            amount
            currency
          }
        }
      }
    }
  }
`;
